import { SYNC_ENGINE_CHAT_SPACE_ACCOUNT_ID } from "@/store/chat/constants";

export const isSystemMessage = (message: { sent_by_space_account_id: string }) => {
  return (
    message.sent_by_space_account_id.toUpperCase() ===
    SYNC_ENGINE_CHAT_SPACE_ACCOUNT_ID.toUpperCase()
  );
};
